import { Helmet } from 'react-helmet-async';

import { seoData, type seoPageTypes } from './Seo.helpers';

export const Seo = ({ page }: { page: seoPageTypes }) => (
	<Helmet data-testid='seo'>
		<title>{seoData[page].title}</title>
		<meta
			name='description'
			content={seoData[page].description}
		/>
	</Helmet>
);
